import { render, staticRenderFns } from "./DiscoveryRow.vue?vue&type=template&id=eff7d140"
import script from "./DiscoveryRow.vue?vue&type=script&lang=js"
export * from "./DiscoveryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports